import store from '@/store/index'

/**
 * 檢查使用者是否有指定的團隊角色權限
 * @param {string} role - 要檢查的權限名稱
 * @returns {boolean} - 如果有該權限則回傳 true，否則回傳 false
 *
 * @example
 * // 檢查是否有機場接送權限
 * if (hasTeamRole('airport_transfer')) {
 *   // 顯示機場接送功能
 * }
 *
 * @example
 * // 在 template 中使用
 * <button v-if="hasTeamRole('pregnant_ride')">好孕專車</button>
 */
export function hasTeamRole(role) {
  if (!role || typeof role !== 'string') {
    return false
  }

  const teamRoles = store.getters['managerStore/getTeamRoles']

  if (!Array.isArray(teamRoles)) {
    return false
  }

  return teamRoles.includes(role)
}

/**
 * 檢查使用者是否有任一指定的團隊角色權限
 * @param {string[]} roles - 要檢查的權限名稱陣列
 * @returns {boolean} - 如果有任一權限則回傳 true，否則回傳 false
 *
 * @example
 * // 檢查是否有機場接送或好孕專車權限
 * if (hasAnyTeamRole(['airport_transfer', 'pregnant_ride'])) {
 *   // 顯示相關功能
 * }
 */
export function hasAnyTeamRole(roles) {
  if (!Array.isArray(roles) || roles.length === 0) {
    return false
  }

  return roles.some((role) => hasTeamRole(role))
}

/**
 * 檢查使用者是否有所有指定的團隊角色權限
 * @param {string[]} roles - 要檢查的權限名稱陣列
 * @returns {boolean} - 如果有所有權限則回傳 true，否則回傳 false
 *
 * @example
 * // 檢查是否同時有企業簽約和企業管理權限
 * if (hasAllTeamRoles(['enterprise_sign', 'enterprise_management'])) {
 *   // 顯示完整企業功能
 * }
 */
export function hasAllTeamRoles(roles) {
  if (!Array.isArray(roles) || roles.length === 0) {
    return false
  }

  return roles.every((role) => hasTeamRole(role))
}

/**
 * 取得所有團隊角色權限
 * @returns {string[]} - 回傳所有權限陣列
 *
 * @example
 * const roles = getTeamRoles()
 * console.log(roles) // ['enterprise_sign', 'dispatch_schedule', ...]
 */
export function getTeamRoles() {
  return store.getters['managerStore/getTeamRoles'] || []
}



// WEBPACK FOOTER //
// ./src/utils/teamRoleAuth.js